import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ApiService} from '../../services/api.service';


@Component({
  selector: 'app-image-viewer-modal.',
  templateUrl: './imageViewerModal..component.html',
  styleUrls: ['./imageViewerModal.component.css']
})
export class ImageViewerModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ImageViewerModalComponent>,
    public  apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) {
    // console.log(modalData);
  }
  rotateDeg:any =0;
   zoom: any = 1;

  ngOnInit() {
    // this.url=this.modalData.url;
  }

  actionFunction() {
    this.modalData.function();
    // this.closeModal();
  }

  closeModal() {
    this.dialogRef.close();
  }
rotate(){
    this.rotateDeg =this.rotateDeg +90
   const img= document.getElementById('viewableImage') as HTMLImageElement;
   img.style.transform=`rotate(${this.rotateDeg}deg)`
}

  zoomIn(direction) {

    const delta = 100 * direction;

    const element = document.getElementById('viewableImage');
    const positionInfo = element.getBoundingClientRect();

    element.style.width = positionInfo.width+delta+'px';
    element.style.height = positionInfo.height+delta+'px';
  }
}
